import TableBuilding from './components/TableBuilding'

export default function Building() {
  return <TableBuilding />
}
